import React from 'react';
import InputMask from 'react-input-mask';

function CpfCnpjInput({ value, onChange, disabled, style, errorStyle }) {
  function formatCpfCnpj(value) {
    const numbers = value.replace(/\D/g, '');
  
    if (numbers.length <= 11) {
      // Formata como CPF
      return numbers
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
    } else {
      // Formata como CNPJ
      return numbers
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
        .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
    }
  }
  const handleInputChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, ''); // só números
    onChange({
      ...e,
      target: {
        ...e.target,
        value: rawValue,
      },
    });
  };  

  return (
    <input
      type="text"
      value={formatCpfCnpj(value)}
      onChange={handleInputChange}
      placeholder="Digite CPF ou CNPJ"
      disabled={disabled}
      style={{
        ...style,
        ...(errorStyle || {}),
      }}
      maxLength={18} // suficiente para CNPJ formatado
    />
  );
}

export default CpfCnpjInput;
